import React, { useMemo } from "react";
import Collapsable from "../custom/Collapsable";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import chunk from "lodash/chunk";
import find from "lodash/find";
import has from "lodash/has";
import renderHTML from "lib/render-html";

const useStyles = makeStyles((theme) => ({
  root: {},
  list: {
    padding: 0,
    margin: 0,
    listStyle: "none",
    "& li": {
      borderLeft: "3px solid",
      paddingLeft: 12,
      margin: theme.spacing(1.5, 0),
    },
    "& li:nth-child(even)": {
      borderColor: theme.palette.success.main,
    },
    "& li:nth-child(odd)": {
      borderColor: theme.palette.primary.main,
    },
  },
}));

const TargetAudience: React.FC<TargetAudienceProps> = ({ content }) => {
  const classes = useStyles();

  //filtring data as per the component requirement
  const data = useMemo(() => {
    const list = find(content.contents, (i) => i.list.length > 0);
    return {
      heading: content.topic_name,
      subHeading: content.sub_heading,
      points:
        has(list, "list") && list.list.length > 8
          ? {
              first: chunk(list.list, Math.round(list.list.length / 2))[0],
              second: chunk(list.list, Math.round(list.list.length / 2))[1],
            }
          : {
              first: has(list, "list") ? list.list : [],
              second: [],
            },
    };
  }, [content]);

  return (
    <Collapsable heading={data.heading} isOpen={true}>
      <Box>
        <Typography gutterBottom paragraph>
          {data.subHeading}
        </Typography>
        <Grid container spacing={3}>
          <Grid
            item
            xs={12}
            sm={12}
            md={data.points.second.length === 0 ? 12 : 6}
            lg={data.points.second.length === 0 ? 12 : 6}
          >
            <ul className={classes.list}>
              {data.points.first?.map((item, index) => (
                <li key={`target-audance-of-course-` + index}>
                  {renderHTML(item)}
                </li>
              ))}
            </ul>
          </Grid>
          {data.points.second.length > 0 && (
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <ul className={classes.list}>
                {data.points.second?.map((item, index) => (
                  <li key={`target-audance-of-course-` + index}>
                    {renderHTML(item)}
                  </li>
                ))}
              </ul>
            </Grid>
          )}
        </Grid>
      </Box>
    </Collapsable>
  );
};

export default TargetAudience;
